import AdminHubspotSettings from './AdminHubspotSettings';

export default AdminHubspotSettings;
